import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcaseTag16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSuitcaseTag16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 2h2a1 1 0 0 1 1 1v1H6V3a1 1 0 0 1 1-1M5 4V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm1 6v3h4V5H6v2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1zm-1 0H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2zm.5-2H4v1h3V8zM13 5h-2v8h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcaseTag16);
